import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';

import {
  FlipContainer,
  FlipInnerContainer,
  FlipFront,
  FlipBack,
  Image,
} from './styles';

const Card3D = ({
  urlImg,
  name,
  techs,
  description,
  urlDeploy,
  urlRepository,
}) => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <FlipContainer data-aos='zoom-in'>
      <FlipInnerContainer className='rotate-flip'>
        <FlipFront>
          <Image background={urlImg} />
        </FlipFront>
        <FlipBack>
          <h1>{name}</h1>
          <p>{description}</p>
          <p>Built with {techs}</p>
          {urlDeploy && <a href={urlDeploy} target='_blank' rel='noreferrer'>
            ACCESS
          </a>}
          <a href={urlRepository} target='_blank' rel='noreferrer'>
            REPOSITORY
          </a>
        </FlipBack>
      </FlipInnerContainer>
    </FlipContainer>
  );
};

export default Card3D;
